import {
  Component,
  ChangeDetectionStrategy,
  computed,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';

import { CartService } from '../../../core/services/cart/cart.service';
import { ButtonDirective } from '../../directives/button.directive';
import { ProductImgFallbackDirective } from '../../directives/product-img-fallback.directive';
import { SeparatorDirective } from '../../directives/separator.directive';
import { ClpCurrencyPipe } from '../../pipes/clp-currency.pipe';
import { CartControlsComponent } from '../cart-controls/cart-controls.component';
import { ProductTitlePipe } from '../../pipes/product-title.pipe';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  imports: [
    ClpCurrencyPipe,
    MatIconModule,
    RouterLink,
    ButtonDirective,
    SeparatorDirective,
    CartControlsComponent,
    ProductImgFallbackDirective,
    ProductTitlePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartComponent {
  private readonly router = inject(Router);
  protected readonly cartService = inject(CartService);

  private readonly currentRoute = signal(this.router.url);

  protected readonly hideCart = computed(() => {
    const route = this.currentRoute();
    return route === '/checkout' || route === '/order-success';
  });

  protected readonly items = this.cartService.items;

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        takeUntilDestroyed(),
      )
      .subscribe((event) => {
        this.currentRoute.set(event.url);
        if (this.hideCart()) {
          this.cartService.setCartOpen(false);
        }
      });
  }

  protected closeCart(): void {
    this.cartService.setCartOpen(false);
  }

  protected removeItem(productId: string): void {
    this.cartService.removeItem(productId);
  }
}
